import React, { useState } from "react";
import * as S from "./styles.ts";
import { InputProps } from "./types";
import { useTheme } from "../../../contexts/ThemeContext.tsx";
import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const PasswordInput: React.FC<InputProps> = ({
  label,
  error,
  register,
  ...rest
}) => {
  const { darkMode } = useTheme();
  const [showPassword, setShowPassword] = useState(false);

  const toggleVisibility = () => setShowPassword((prev) => !prev);
  const handleMouseDownPassword = (e: React.MouseEvent<HTMLButtonElement>) => e.preventDefault();

  return (
    <S.StyledTextField
      {...register}
      {...rest}
      type={showPassword ? "text" : "password"}
      label={label}
      variant="outlined"
      error={!!error}
      helperText={error?.message}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
              onClick={toggleVisibility}
              onMouseDown={handleMouseDownPassword}
              edge="end"
              sx={{ color: darkMode ? "#94a3b8" : undefined }}
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      sx={{
        "& label": { color: darkMode ? "#fff" : "" },
        "& .MuiOutlinedInput-root": {
          color: darkMode ? "#fff" : "",
          "& fieldset": { borderColor: darkMode ? "gray" : "" },
          "&:hover fieldset": { borderColor: darkMode ? "gray" : "" },
          "&.Mui-focused fieldset": {
            borderColor: darkMode ? "gray" : "",
          },
        },
      }}
    />
  );
};

export default PasswordInput;
